import { Component,  Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'action-button',
    template: `
<button mat-button color="primary"  [disabled]="disabled">
  {{ text }}
  <ng-content></ng-content>
</button>
`,
    styleUrls: ['./action-button.scss'],
    imports: [MatButtonModule],
    standalone: true
})
export class ActionButtonComponent {
  @Input() text: string
  @Input() minWidth = 'unset !important'
  @Input() disabled = false
}

